import styled from "styled-components";

export const DashboardContent = styled.div`
  width: 100vw;
  height: 100vh;

 
`;
